<template>
    <div class="edit-similar">
        <SimilarText @similarAddClick="similarAddClick"></SimilarText>
        <div class="similar-que-box">
            <SimilarSearch :placeholder="placeholder" @searchSimilar="searchChange" />
            <SimilarList :data="getSimilarData" @checkChange="itemCheckChange" @similarEditClick="similarEditClick"> </SimilarList>
            <div class="page-control">
                <SimilarOptions :allCheck="allCheckFlag" @deleteSimilar="deleteSimilar" @checkAllChange="checkAllChange">
                    <Button
                        slot="customBtn"
                        @btnClick="transferSimilar"
                        :text="transferBtn.text"
                        :icon="transferBtn.icon"
                        :hoverIcon="transferBtn.hoverIcon"
                    ></Button>
                </SimilarOptions>
                <PageControl
                    :total="totalsSimilar"
                    :curPage="curPage"
                    :lengthRank="pageLengthRank"
                    :pageLength="pageLength"
                    @pageChange="pageChange"
                />
                <div class="page-rank">
                    <PageLengthSelect :pageRank="pageLengthRank" :curLength="pageLength" @lengthChange="lengthChange" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SimilarText from "./SimilarText";
import PageControl from "@/views/zhiji/bComponents/pageController/PageControl";
import SimilarOptions from "./SimilarOptions";
import SimilarList from "./SimilarList";
import PageLengthSelect from "@/views/zhiji/bComponents/pageController/PageLengthSelect";
import Button from "@/views/zhiji/bComponents/buttons/Button";
import SimilarSearch from "./SimilarSearch";

import { STATIC_IMG_PATH } from "@/views/zhiji/js/common/constants.js";
import { debounce } from "@/views/zhiji/js/common/util.js";
import i18n from "@/i18n";

export default {
    name: "ExistingSimilars",
    components: {
        SimilarText,
        PageControl,
        SimilarOptions,
        SimilarList,
        PageLengthSelect,
        Button,
        SimilarSearch
    },
    data() {
        return {
            checkedRows: [],
            curPage: 1,
            pageLengthRank: ["10", "20", "30"],
            pageLength: "10"
        };
    },
    mounted() {
        this.searchHanlder = debounce(data => {
            let searchField = data[0];
            this.searchSimilar(searchField);
        }, 500);
    },
    computed: {
        getSimilarData() {
            return this.convertListData(this.getStorePorp("similar"));
        },
        allCheckFlag() {
            return this.checkedRows.length !== 0 && this.getSimilarData.length == this.checkedRows.length;
        },
        placeholder() {
            return this.$t("zhiji.knowlege.quesEditModal.searchSimilar");
        },
        totalsSimilar() {
            return this.getStorePorp("matchSimilarTotal");
        },
        transferBtn() {
            return {
                text: this.$t("zhiji.knowlege.transferTo"),
                icon: "url(" + STATIC_IMG_PATH + "class-spr.png) no-repeat -191px 0px",
                hoverIcon: "url(" + STATIC_IMG_PATH + "class-spr.png) no-repeat -191px -20px"
            };
        }
    },
    methods: {
        transferSimilar() {
            if (this.checkedRowsTips() || this.similarTransferTips()) {
                return;
            }

            let checkedSimilars = [];
            this.getSimilarData.map(similar => {
                return (
                    similar.checked &&
                    checkedSimilars.push({
                        questionId: similar.extQuestionId,
                        questionText: similar.extQuestion
                    })
                );
            });

            this.$store.dispatch("zhiji/showModal", {
                type: "LinkedQuestionModal",
                data: {
                    question: checkedSimilars,
                    title: i18n.t("zhiji.knowlege.transToOther"),
                    unableEdit: true,
                    confirm: data => {
                        this.zhiji
                            .requestByServiceName("transferSimilars", {
                                questionId: data.linkQuestionId,
                                similarIds: data.questionIdArray
                            })
                            .then(() => {
                                this.querySimilarList();
                                this.$store.dispatch("zhiji/showModal", {
                                    type: "MessageModal",
                                    data: {
                                        type: "tip",
                                        message: i18n.t("zhiji.knowlege.transSuccess"),
                                        cancel: () => {},
                                        confirm: () => {}
                                    }
                                });
                            });
                    },
                    cancel: () => {}
                }
            });
        },
        checkedRowsTips() {
            if (this.checkedRows.length === 0) {
                let configText = i18n.t("zhiji.knowlege.quesEditModal.similarErrTip");
                this.$store.dispatch("zhiji/showModal", {
                    type: "MessageModal",
                    data: {
                        type: "tip",
                        message: configText
                    }
                });
                return true;
            }
        },
        similarTransferTips() {
            let flag = this.getSimilarData.some(item => item.checked && item.updateState.length);
            if (flag) {
                this.$store.dispatch("zhiji/showModal", {
                    type: "MessageModal",
                    data: {
                        type: "tip",
                        message: i18n.t("zhiji.knowlege.onlineBefore")
                    }
                });
                return true;
            }
        },
        getStorePorp(propName) {
            return this.$store.state.zhiji.questionEdit[propName];
        },
        currentQuestionId() {
            return this.getStorePorp("questionInfo").questionId;
        },
        pageChange(page) {
            if (this.pageLength == page.pageLength && this.curPage == page.curPage) {
                return;
            }
            this.curPage = page.curPage;
            this.pageLength = page.pageLength;
            this.querySimilarList();
        },
        lengthChange(pageLen) {
            this.pageLength = pageLen;
            this.querySimilarList();
        },
        querySimilarList(extQuestion) {
            this.$store.dispatch("zhiji/querySimilarList", {
                extQuestion: extQuestion || "",
                questionId: this.currentQuestionId(),
                pageNo: this.curPage,
                pageSize: this.pageLength
            });
            this.removeAllChecked();
        },
        checkAllChange(data) {
            data.checked ? this.allPageChecked() : this.removeAllChecked();
        },
        removeAllChecked() {
            this.checkedRows.splice(0);
        },
        allPageChecked() {
            let similarList = this.getStorePorp("similar");

            similarList.forEach(similar => {
                this.itemCheckChange({
                    extQuestionId: similar.extQuestionId,
                    checked: true
                });
            });
        },
        searchChange(data) {
            this.searchHanlder(data);
        },
        searchSimilar(data) {
            this.curPage = 1;
            this.querySimilarList(data.keywords);
        },
        similarEditClick(data) {
            data.questionId = this.currentQuestionId();
            data.pageNo = this.curPage;
            this.$store.dispatch("zhiji/updateSimilar", data);
        },
        similarAddClick(data) {
            let params = {
                questionId: this.currentQuestionId(),
                similarArr: data
            };
            data.length > 100
                ? this.$message({
                      message: i18n.t("zhiji.knowlege.quesEditModal.addSimilarWarnTip"),
                      center: true,
                      duration: 2000,
                      type: "warning"
                  })
                : this.$store.dispatch("zhiji/addSimilar", params);
        },
        deleteSimilar() {
            let configText = i18n.t("zhiji.knowlege.delSimilarTip");
            this.checkedRows.length === 0
                ? (configText = i18n.t("zhiji.knowlege.quesEditModal.similarErrTip"))
                : this.checkedRows.length > 1
                ? (configText = i18n.t("zhiji.knowlege.delSimilarsTip"))
                : "";

            this.$store.dispatch("zhiji/showModal", {
                type: "MessageModal",
                data: {
                    type: "tip",
                    message: configText,
                    confirm: () => {
                        this.deleteCheckedRows();
                    }
                }
            });
        },
        deleteCheckedRows() {
            if (this.checkedRows.length > 0) {
                this.$store.dispatch("zhiji/deleteSimilar", {
                    questionId: this.currentQuestionId(),
                    deleteSimilarIds: this.checkedRows
                });
                this.checkedRows.splice(0);
            }
        },
        itemCheckChange(data) {
            if (data.checked) {
                this.checkedRows.indexOf(data.extQuestionId) === -1 && this.checkedRows.push(data.extQuestionId);
            } else {
                let itemcheckedIdx = this.checkedRows.indexOf(data.extQuestionId);
                itemcheckedIdx !== -1 && this.checkedRows.splice(itemcheckedIdx, 1);
            }
        },
        convertListData(similars) {
            return similars.map(similar => {
                return {
                    checked: this.getCheckState(similar.extQuestionId),
                    updateState: similar.updateState,
                    extQuestion: similar.extQuestion,
                    extQuestionId: similar.extQuestionId,
                    questionId: similar.questionId,
                    sceneId: similar.sceneId
                };
            });
        },
        getCheckState(extQuestionId) {
            return this.checkedRows.some(item => item === extQuestionId);
        }
    }
};
</script>

<style lang="scss" scoped>
.edit-similar {
    display: flex;
    flex-direction: column;
    height: 100%;
    flex: 1;
    padding: 8px 0 0 0;
    box-sizing: border-box;
    margin: 0 35px 0 16px;
    .similar-que-box {
        display: flex;
        flex-direction: column;
        margin: 16px 0 16px 0;
        border: 1px solid #d8e4f0;
        border-radius: 4px;
        min-height: 330px;
    }
    .page-control {
        font-size: 12px;
        padding: 4px 0;
        border-top: 1px solid #d8e4f0;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        text-align: center;
        color: rgba(65, 71, 94, 0.7);
        background: #fafbfd;
        border-radius: 0 0 4px 4px;
        .page-rank {
            position: absolute;
            margin: 0 30px 0 0;
            right: 0px;
        }
    }
    .page-control:after {
        content: " ";
        clear: both;
        height: 0;
        visibility: hidden;
        display: block;
    }
}
</style>
